import React, { useMemo } from 'react'

import { SelectInput } from '@src/components/Inputs/SelectInput/SelectInput'
import { Table } from '@src/graphql-types'

import { createTableOptions } from '@src/utils/createTableOptions'
import { Container } from './TableSelect.styles'

export const TableSelect: React.FC<{
  tables: Pick<Table, 'id' | 'friendlyName'>[]
  selectedTableId?: string
  setSelectedTableId: (tableId: string) => void
  dataTestId?: string
}> = ({ tables, selectedTableId, setSelectedTableId, dataTestId }) => {
  const tableOptions = useMemo(() => createTableOptions(tables), [tables])
  return (
    <>
      <Container>
        <SelectInput
          label={''}
          name={'tableId'}
          options={tableOptions}
          required
          onChange={table => {
            setSelectedTableId(table.value)
          }}
          selectedOptionValue={selectedTableId}
          dataTestId={dataTestId}
        />
      </Container>
    </>
  )
}
